(() => {
    "use strict"

    // for Safari/Firefox
    function addStopPropagationToVariantSelect() {
        $( '.swiper-wrapper select.product-form__variants' ).each(function(index, el) {
          $(el).on('pointerdown', function(evt){ evt.stopPropagation() } )
        })
    }
	
    function showPopupCollection() {
        document.querySelectorAll('#shop_the_look .collection-items').forEach((elm, idx) => {
			
			slideListProducts(elm, elm.querySelector('.swiper-container'));
			slideShowGalleryProduct(elm);
			changeVariantProduct(elm);
        });
    }

    function slideListProducts(elm, items) {

        const swiper = new Swiper(items, {
            // Optional parameters
            slidesPerView: items.querySelectorAll('.swiper-slide').length > 3 ? 3 : items.querySelectorAll('.swiper-slide').length,
            loopFillGroupWithBlank: true,
            pagination: {
                el: items.parentNode.querySelector('.swiper-pagination'),
                clickable: true
            },
            loop: false,
            spaceBetween: 3,
            breakpoints: {
                320: {
                    slidesPerView: 2,
                    spaceBetween: 3,
                    slidesPerGroup: 2
                }, 
                480: {
                    slidesPerView: 2,
                    spaceBetween: 3,
                    slidesPerGroup: 2
                },
                640: {
                    slidesPerView: 3,
                    spaceBetween: 3,
                    slidesPerGroup: 3
                }
              }
        });
        swiper.on('afterInit beforeSlideChangeStart slideChange', () => {
            slideShowGalleryProduct(elm);
        });
    }

    function slideShowGalleryProduct(elm) {
        let wrapperSliderShow = elm.querySelectorAll(".gellary_image-product");
        wrapperSliderShow.forEach((elm, idx) => {

             $(elm).not('.slick-initialized').slick();
			 $(elm).slick('setPosition');
             let currentSlide = $(elm).slick('slickCurrentSlide');
             if (currentSlide == 0) {
                 if ( elm.querySelector('.slick-prev')){
                    elm.querySelector('.slick-prev').setAttribute("disabled", "disabled");
                    elm.querySelector('.slick-prev').style.opacity = "0.5";
                 }
             }else {
                if( elm.querySelector('.slick-prev')){
                    elm.querySelector('.slick-prev').removeAttribute("disabled", "");
                    elm.querySelector('.slick-prev').style.opacity = "1";
                } 
             }
			 
             $(elm).on('init reInit beforeChange', function (event, slick, currentSlide, nextSlide) {
                if (nextSlide == 0) {
                    elm.querySelector('.slick-prev').setAttribute("disabled", "disabled");
                    elm.querySelector('.slick-prev').style.opacity = "0.5";
                } else {
                    elm.querySelector('.slick-prev').removeAttribute("disabled", "");
                    elm.querySelector('.slick-prev').style.opacity = "1";
                }

                if (nextSlide > 1 && nextSlide >= (slick.slideCount - 1)) {
                    elm.querySelector('.slick-next').setAttribute("disabled", "disabled");
                    elm.querySelector('.slick-next').style.opacity = "0.5";
                } else {
                    elm.querySelector('.slick-next').removeAttribute("disabled", "");
                    elm.querySelector('.slick-next').style.opacity = "1";
                }
             });
        });
    }

    function setPositionThumnSlider(elm, index) {
        $(elm).not('.slick-initialized').slick({
            speed: 500
        });
        $(elm).on('setPosition afterChange', function(event, slick, currentSlide){
            setOptionsVariant(elm,currentSlide);
        });
        if (index != null) {
            $(elm).slick('slickGoTo', index);
        }
    }

    function setOptionsVariant(elm, currentSlide) {
        let productId = $(elm).data('idproduct');
        let variantsJson = 'VariantsJson-' + productId;
        let optionVariants = '#Options-'+ productId;
        let variantsObject = JSON.parse(document.getElementById(variantsJson).innerHTML);
        let positionImage = currentSlide + 1;
        return false;
        for (let i = 0; i < variantsObject.length; i++){
            if (variantsObject[i].featured_image) {
                if (variantsObject[i].featured_image.position == positionImage) {
                    $(optionVariants).find("option").each((idx, item) => {
                        if (variantsObject[i].id == item.value) {
                            $(item).attr("selected", true).siblings()
                                .removeAttr("selected");
                        }
                    });
                    break;
                }
                
            }
        }
    }

    function loopCheckPositionThumnSlider(variantsObject, sliderId, index) {
        for (let i = 0; i < variantsObject.length; i++){
            if (variantsObject[i].id == index) {
                if (variantsObject[i].featured_image) { 
                    let newImage = $('.grid__image-ratio[data-id="' + variantsObject[i].featured_image.id + '"]');
                    let indexImage = newImage.data().slickIndex;
                    setPositionThumnSlider(sliderId, indexImage);
                }
                break;
            }
        }
    }

    function changeLinkViewProduct(elm, id) {
        let href = $(elm).attr("href");
        let http = window.location.protocol + "//" + window.location.host;
        let url = new URL(http+href);
        let new_url = url.pathname + "?variant=" + id;
        $(elm).attr("href", new_url);
    }

    function changeVariantProduct(elm) {
        let selection = elm.querySelectorAll('.product-form__variants');
        selection.forEach((item, idx) => {
            let slideId = item.dataset.slideid;
            let productId = item.dataset.productid;
            let variantsJson = 'VariantsJson-' + productId;
            let variantsObject = JSON.parse(document.getElementById(variantsJson).innerHTML);
            let sliderId = '#Slider-' + slideId + '-' + productId;
            let linkViewProduct = "#ViewProduct-" + slideId + '-' + productId;

            if (item.options[item.selectedIndex] != null ) {
                let valueDefault = item.options[item.selectedIndex].value;
                loopCheckPositionThumnSlider(variantsObject, sliderId, valueDefault);
            }
            item.addEventListener('change', (e) => {  
                loopCheckPositionThumnSlider(variantsObject, sliderId, item.value);
                changeLinkViewProduct(linkViewProduct, item.value);
            });
        });
    }

    function ajaxAddToCartPopup() {
        let _config = {
    
            // What you might want to change
            addToCartBtnLabel:             'Add to cart',
            addedToCartBtnLabel:           'Thank you!',
            addingToCartBtnLabel:          'Adding...',
            soldOutBtnLabel:               'Sold Out',
            howLongTillBtnReturnsToNormal: 1000, 
            feedbackPosition:              '',
            cartBubble:                    '.cart-link__bubble',
            addToCartBtnSelector:          '.js-add-to-cart',
            addToCartFormSelector:         'form[action="/cart/add"]',
            shopifyAjaxAddURL:             '/cart/add.js',
            shopifyAjaxCartURL:            '/cart.js'
        };
        let _setText = function($button, label) {
            if ($button.children().length) {
              $button.children().each(function() {
                if ($.trim($(this).text()) !== '') {
                  $(this).text(label);
                }
              });
            }
            else {
              $button.val(label).text(label);
            }
        };
        $(_config.addToCartFormSelector).submit(function(e) {
            e.preventDefault();
            let $addToCartForm = $(this);
            let $addToCartBtn = $addToCartForm.find(_config.addToCartBtnSelector);
            _setText($addToCartBtn, _config.addingToCartBtnLabel);
            $addToCartBtn.addClass('disabled').prop('disabled', true);
            // Add to cart.
            $.ajax({
              url: _config.shopifyAjaxAddURL,
              dataType: 'json',
              type: 'post',
              data: $addToCartForm.serialize(),
              success: function(itemData) {
                // Re-enable add to cart button.
                $addToCartBtn.addClass('inverted');
                _setText($addToCartBtn, _config.addedToCartBtnLabel);
                window.setTimeout(function(){
                  $addToCartBtn.prop('disabled', false).removeClass('disabled').removeClass('inverted');
                  _setText($addToCartBtn,_config.addToCartBtnLabel);
                }, _config.howLongTillBtnReturnsToNormal);
                // Update cart count and show cart link.
                $.getJSON(_config.shopifyAjaxCartURL, function (cart) {
                    if (theme.settings.cartType === 'drawer') {
                        new theme.CartDrawer();
                    }
                    $(_config.cartBubble).addClass('cart-link__bubble--visible');
                });        
              }, 
              error: function(XMLHttpRequest) {
                  console.warn(`Error ! Please check your ${XMLHttpRequest}`);
              }
            });   
            return false;    
        });
       
    }

	function loadMoreCollection(){
		let button = $("#load_more_collection");
		let itemCollection = $("#shop_the_look .collection-items");
        let windowsize = $(window).width();
		let itemShow = 3;

        if(windowsize <= 765){
            itemShow= 1;
            if(itemCollection.length > 1){
                $(button).css({"display":"block"});
            }else{
                $(button).css({"display":"none"});
            }
            $("#shop_the_look .collection-items").slice(0,itemShow).show();
        }

        if(itemCollection.length > itemShow ){
            $(button).css({"display":"block"});
            $("#shop_the_look .collection-items").slice(0,itemShow).show();
        }else{
            itemShow = itemCollection.length
            $(button).css({"display":"none"});
            $("#shop_the_look .collection-items").slice(0,itemShow).show();
        }

		$(button).on("click", (e) => {
            e.preventDefault();
            itemShow = ((itemShow + 3) < itemCollection.length) ? (itemShow + 3) : itemCollection.length;
            $("#shop_the_look .collection-items:hidden").slice(0,3).show(); 
            showPopupCollection();
			if(itemShow >= itemCollection.length){
				$(button).hide();
			}else{
				$(button).show();
			}
			
		})
		
	}

    $(document).ready(function () {
		loadMoreCollection();
        showPopupCollection();
        ajaxAddToCartPopup();
        addStopPropagationToVariantSelect();
    });
})(theme.jQuery);